import { createStyles, Drawer } from '@mantine/core';
import { Text } from '@repo/foundations';
import { observer } from 'mobx-react-lite';
import { Suspense } from 'react';
import type { SecodaEntity } from '../../lib/models';
import { ErrorBoundary } from '../ErrorBoundary';
import { SmallLoadingSpinner } from '../LoadingSpinner';
import ActivityLog from './ActivityLog';

interface IActivityLogDrawerProps {
	entity?: Pick<SecodaEntity, 'id' | 'entity_type' | 'created_at'>;
	onClose: () => void;
	open: boolean;
}

const useStyles = createStyles((theme) => ({
	content: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		paddingLeft: `${theme.other.space[6]}px`,
	},
	body: {
		height: 'calc(100% - 72px)',
		overflowY: 'auto',
		padding: 0,
	},
	header: {
		padding: `${theme.other.space[3]}px 0px`,
	},
}));

const ActivityLogDrawer = observer(
	({ entity, open, onClose }: IActivityLogDrawerProps) => {
		const { classes } = useStyles();

		return (
			<Drawer
				classNames={classes}
				opened={open}
				onClose={onClose}
				title={
					<Text size="md" weight="bold">
						Activity
					</Text>
				}
				size="xl"
				position="right"
			>
				{open && (
					<ErrorBoundary>
						<Suspense fallback={<SmallLoadingSpinner />}>
							<ActivityLog entity={entity} />
						</Suspense>
					</ErrorBoundary>
				)}
			</Drawer>
		);
	}
);

export default ActivityLogDrawer;
